// Generated by ts-to-zod
import { z } from 'zod';
import { queueRuleSchema } from '../models/queueRule.schema';

export const rulePatchPayloadSchema = queueRuleSchema.partial();
